// import { downloadBlob } from "@hooks/utils/useUpload";
import { ProjectLineItem } from "@interfaces/project";
// import { Template, BLANK_PDF } from '@pdfme/ui'; <- Template types and BLANK_PDF can also be imported from @pdfme/ui.
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import { toJpeg } from "html-to-image";
import { downloadBlob } from "@hooks/utils/useUpload";

const createPdf = async (
  selectedProject: ProjectLineItem,
  chart0: React.MutableRefObject<HTMLDivElement | undefined>,
  chart1: React.MutableRefObject<HTMLDivElement | undefined>,
  chart2: React.MutableRefObject<HTMLDivElement | undefined>,
  chart3: React.MutableRefObject<HTMLDivElement | undefined>,
  chart4: React.MutableRefObject<HTMLDivElement | undefined>,
  chart5: React.MutableRefObject<HTMLDivElement | undefined>,
  chart6: React.MutableRefObject<HTMLDivElement | undefined>,
  chart7: React.MutableRefObject<HTMLDivElement | undefined>
) => {
  const pdfDoc = await PDFDocument.create();
  const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman);

  const page = pdfDoc.addPage();
  const { width, height } = page.getSize();
  const fontSize = 30;
  page.drawText(selectedProject.projectName, {
    x: width / 2,
    y: height - 4 * fontSize,
    size: fontSize,
    font: timesRomanFont,
    color: rgb(0, 0.53, 0.71),
  });

  page.drawText(selectedProject.projectAddressLine1, {
    x: width / 2,
    y: height - 8 * fontSize,
    size: fontSize,
    font: timesRomanFont,
    color: rgb(0, 0.53, 0.71),
  });

  page.drawText(selectedProject.projectAddressLine2, {
    x: width / 2,
    y: height - 16 * fontSize,
    size: fontSize,
    font: timesRomanFont,
    color: rgb(0, 0.53, 0.71),
  });

  if (chart0.current) {
    const divElement = chart0.current;
    const jpgData = await toJpeg(divElement);
    const jpgImage = await pdfDoc.embedJpg(jpgData);

    const jpgDims = jpgImage.scale(0.5);

    page.drawImage(jpgImage, {
      x: 0,
      y: jpgDims.height,
      width: jpgDims.width,
      height: jpgDims.height,
    });
  }

  if (chart1.current) {
    const divElement = chart1.current;
    const jpgData = await toJpeg(divElement);
    const jpgImage = await pdfDoc.embedJpg(jpgData);

    const jpgDims = jpgImage.scale(0.5);

    page.drawImage(jpgImage, {
      x: 0,
      y: jpgDims.height * 2,
      width: jpgDims.width,
      height: jpgDims.height,
    });
  }

  if (chart2.current) {
    const divElement = chart2.current;
    const jpgData = await toJpeg(divElement);
    const jpgImage = await pdfDoc.embedJpg(jpgData);

    const jpgDims = jpgImage.scale(0.5);

    page.drawImage(jpgImage, {
      x: 0,
      y: jpgDims.height * 3,
      width: jpgDims.width,
      height: jpgDims.height,
    });
  }

  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  downloadBlob(blob, "report.pdf");
};

export const generatePDFReport = async (
  selectedProject: ProjectLineItem,
  chart0: React.MutableRefObject<HTMLDivElement | undefined>,
  chart1: React.MutableRefObject<HTMLDivElement | undefined>,
  chart2: React.MutableRefObject<HTMLDivElement | undefined>,
  chart3: React.MutableRefObject<HTMLDivElement | undefined>,
  chart4: React.MutableRefObject<HTMLDivElement | undefined>,
  chart5: React.MutableRefObject<HTMLDivElement | undefined>,
  chart6: React.MutableRefObject<HTMLDivElement | undefined>,
  chart7: React.MutableRefObject<HTMLDivElement | undefined>
) => {
  await createPdf(
    selectedProject,
    chart0,
    chart1,
    chart2,
    chart3,
    chart4,
    chart5,
    chart6,
    chart7
  );
};
